import {
  TRENDS_FAIL,
  GET_TRENDS,
  SET_TRENDS_LOADING,
  //   CLEAR_ERRORS,
  ADD_TREND,
  GET_UPDATED_TREND_DATA,
  REMOVE_TREND,
  CLEAR_ADDED,
  //   CITIES_FAIL,
} from "../actions/Types";

const initialState = {
  trends: [],
  loading: false,
  error: null,
  cities: [],
  added: false,
  trendObj: [],
};

const variable = (state = initialState, action) => {
  switch (action.type) {
    case GET_TRENDS:
      return {
        ...state,
        loading: false,
        error: null,
        trends: action.payload.data,
        added: false,
      };

    case CLEAR_ADDED:
      return { ...state, added: false };

    case ADD_TREND:
      return {
        ...state,
        loading: false,
        error: null,
        added: true,
        trends: [action.payload.data, ...state.trends],
      };

    case REMOVE_TREND:
      return {
        ...state,
        loading: false,
        error: null,
        added: true,
        trends: state.trends.filter((trend) => trend._id !== action.payload),
      };

    case TRENDS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        trends: [],
      };
    case GET_UPDATED_TREND_DATA:
      return {
        ...state,
        trendObj: action.payload,
        added: false,
      };

    case SET_TRENDS_LOADING:
      return {
        ...state,
        loading: true,
      };

    default:
      return state;
  }
};
export default variable;
